import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

interface SalesTableProps {
  productData: { price: number };
  salesData: any;
  setSalesData: any;
  edit?: boolean;
}

const SalesTable = ({
  productData,
  salesData,
  setSalesData,
  edit
}: SalesTableProps) => {
  const PRODUCT_PRICE = productData.price;
  const { t } = useTranslation();

  useEffect(() => {
    if (!edit) {
      setSalesData({
        price: PRODUCT_PRICE,
        card: 0,
        cash: 0,
        transfer: 0,
        discount: 0,
        totalPrice: 0,
        unpaidPrice: PRODUCT_PRICE
      });
    }
  }, [edit, setSalesData, PRODUCT_PRICE]);

  function comma(str: any) {
    str = String(str);
    return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
  }

  function unComma(str: any) {
    str = String(str);
    return str.replace(/[^\d]+/g, "");
  }

  const handleChange = (e: any) => {
    let temp = {
      ...salesData,
      [e.target.name]: isNaN(parseInt(unComma(e.target.value)))
        ? 0
        : parseInt(unComma(e.target.value))
    };

    temp.totalPrice =
      temp.card * 1 + temp.cash * 1 + temp.transfer * 1 + temp.discount;
    temp.unpaidPrice = temp.price * 1 - temp.totalPrice * 1;

    setSalesData(temp);
  };

  return (
    <div className="salestable">
      <table>
        <tbody>
          <tr>
            <th>{t("sales.card")}</th>
            <td>
              <input
                name="card"
                min="0"
                max="9999999999"
                value={comma(unComma(salesData.card))}
                onChange={handleChange}
                type="text"
                required
              />
            </td>
          </tr>
          <tr>
            <th>{t("sales.cash")}</th>
            <td>
              <input
                name="cash"
                min="0"
                max="9999999999"
                value={comma(unComma(salesData.cash))}
                onChange={handleChange}
                type="text"
                required
              />
            </td>
          </tr>
          <tr>
            <th>{t("sales.transfer")}</th>
            <td>
              <input
                name="transfer"
                min="0"
                max="9999999999"
                value={comma(unComma(salesData.transfer))}
                onChange={handleChange}
                type="text"
                required
              />
            </td>
          </tr>
          <tr>
            <th>{t("sales.discount")}</th>
            <td>
              <input
                name="discount"
                min="0"
                max="9999999999"
                value={comma(unComma(salesData.discount))}
                onChange={handleChange}
                type="text"
                required
              />
            </td>
          </tr>
          <tr className="result">
            <th>{t("sales.totalPrice")}</th>
            <td>
              {salesData.totalPrice?.toLocaleString()} {t("common.KRW")}{" "}
            </td>
          </tr>
          <tr className="exception">
            <th>{t("sales.unpaid")}</th>
            <td>
              {salesData.unpaidPrice?.toLocaleString()} {t("common.KRW")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default SalesTable;
